import { useEffect } from "react";

const upsertMeta = (key, keyName, content) => {
  let el = document.head.querySelector(`meta[${keyName}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(keyName, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function Seo({ title, description, path = "", jsonLd = null }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("og:title", "property", title);
      upsertMeta("twitter:title", "name", title);
    }
    if (description) {
      upsertMeta("description", "name", description);
      upsertMeta("og:description", "property", description);
      upsertMeta("twitter:description", "name", description);
    }
    const url = `${window.location.origin}${path}`;
    upsertMeta("og:url", "property", url);
    upsertMeta("og:type", "property", "website");
    upsertMeta("og:site_name", "property", "Mahaney Law");
    upsertMeta("twitter:card", "name", "summary_large_image");

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "page");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, path, jsonLd]);

  return null;
}
